import React, { createContext, useContext, useEffect, useState } from "react";
import API from "@/lib/api";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [pages, setPages] = useState([]); // páginas públicas publicadas (para el menú)
  const [homePage, setHomePage] = useState(null); // página marcada como inicio (null = home por defecto)

  const load = () => {
    API.get("/content").then((r) => setContent(r.data)).catch(() => {});
    API.get("/pages").then((r) => setPages(r.data.pages.filter((p) => !p.is_home))).catch(() => {});
    API.get("/pages/home").then((r) => setHomePage(r.data.page)).catch(() => setHomePage(null));
  };

  useEffect(() => {
    load();
  }, []);

  const t = (key, fallback) => {
    const v = content?.[key];
    return v === undefined || v === null || v === "" ? fallback : v;
  };

  return (
    <ContentContext.Provider value={{ content, t, pages, homePage, reload: load }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
